"use client"
import React, { useState, useEffect } from "react";
import useApi from "@/components/api/useApi";
import LoadingAnimation from "@/components/shared/LoadingAnimation";
import { useMediaQuery } from "react-responsive";

import MediaItemGalleryView from "@/components/shared/MediaItemGalleryView";

const PostGalleryView = ({ name, post }) => {
  const isSm = useMediaQuery({ query: "(max-width: 767.98px)" });
  const api = useApi();

  const [loaded, setLoaded] = useState(false);
  const [galleryItemList, setGalleryItemList] = useState(null);

  useEffect(() => {
    if (post && post.type === "GALLERY") {
      api
        .getPostGallery(name, post.id)
        .then(gallery => {
          setGalleryItemList(gallery);
          setLoaded(true);
        })
        .catch(error => {
          setLoaded(true);
        });
    }
  }, [post]);

  if (loaded && !isSm && galleryItemList && galleryItemList.length > 0) {
    return (
      <>
        <MediaItemGalleryView mediaItemList={galleryItemList} />
      </>
    );
  } else {
    return (
      <div className="center-child-div-parent" style={{ margin: "2rem" }}>
        <LoadingAnimation />
      </div>
    );
  }
};
export default PostGalleryView;
